// 必须在任何 preact / tdesign-react / stuck-reporter 依赖之前求值。

// 老 WebKit（Mac 版腾讯会议 CEF 内核基于此）缺失 Object.is。
if (typeof Object.is !== 'function') {
  Object.defineProperty(Object, 'is', {
    value: function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      }
      return x !== x && y !== y;
    },
    configurable: true,
    writable: true,
  });
}

// preact 10.3.2 diffElementNodes 会直接读 newVNode.props.is，遇到 props=undefined 就抛
// "undefined is not an object (evaluating 'f.is')"，页面卡加载页。
// preact 有 options.vnode hook（未 mangle，minified 后仍叫 vnode），所有 createVNode 出口都会调它 —— 
// 包括 h()、cloneElement()、以及 diff/children.js 里"从旧 vnode 复制"这条 preact 内部路径
// （这条路径不走 h()，是我们上一版 h() 兜底漏掉的地方）。
try {
  const { options } = require('preact');
  const originalVnodeHook = options.vnode;
  let patchedCount = 0;
  let reportedOnce = false;

  options.vnode = function (vnode) {
    if (vnode && vnode.props == null) {
      patchedCount += 1;
      vnode.props = {};

      if (!reportedOnce) {
        reportedOnce = true;
        const capturedType = vnode.type;
        const snapshotCount = patchedCount;
        // 异步上报，避免在 render 路径里同步做 IO
        setTimeout(function () {
          try {
            const stuck = require('@cloudstudio/stuck-reporter');
            const err = new Error('vnode_undefined_props');
            const stack = err && err.stack ? String(err.stack).split('\n').slice(0, 30).join('\n') : '';
            const vnodeType =
              typeof capturedType === 'string'
                ? capturedType
                : (capturedType && (capturedType.displayName || capturedType.name)) ||
                  String(capturedType).slice(0, 60);
            if (stuck.mark) {
              stuck.mark('preact_vnode_undefined_props', {
                vnodeType,
                stack,
                patchedCount: snapshotCount,
              });
            }
            if (stuck.flush) stuck.flush('preact_undefined_props');
          } catch (_e) {
            // 兜底流程绝不能再抛
          }
        }, 0);
      }
    }
    if (originalVnodeHook) originalVnodeHook(vnode);
  };

  window.__preactPatchStats = function () {
    return { patched: patchedCount };
  };
} catch (_e) {
  // 拿不到 preact 就不 patch，不影响主流程
}
